<input #slider>